"use strict";const e=require("styled-components").css`
    &.DXModelCard {
        position: relative;
        width: 340px;
        max-width: 100%;
    }
    .DXTypography {
        margin: inherit;
    }
    .gallery > .carousel {
        border: 0px solid transparent;
        border-radius: 5px;
        margin-bottom: 10px;
    }
    .DXModelCard-top {
        position: relative;
    }
    .DXModelCard-top-details {
        position: absolute;
        box-sizing: border-box;
        z-index: 3;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        align-items: flex-start;
    }
    .DXModelCard-top-details-no-stickers {
        justify-content: flex-end;
    }
    .DXModelCard-sticker {
        position: relative;
        color: white;
        font-weight: 700;
        font-family: 'source-sans-pro', sans-serif;
        text-transform: uppercase;
        padding: 6px 7px 4px;
        border-radius: 30px;
        letter-spacing: 0.5px;
        font-size: 15px;
        line-height: 12px;
    }
    .DXModelCard-sticker-in-stock {
        position: relative;
        display: flex;
        align-items: center;
        color: rgb(37, 41, 45);
        font-weight: 700;
        font-family: 'source-sans-pro', sans-serif;
        text-transform: uppercase;
        padding: 5px 8px;
        border-radius: 30px;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        background: white;
        .green-dot {
            background-color: rgb(151, 215, 0);
            width: 6px;
            height: 6px;
            margin-right: 4px;
            border-radius: 50%;
        }
    }
    .DXModelCard-top-details {
        position: absolute;
        z-index: 3;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        align-items: flex-start;
    }
    .DXModelCard-link {
        position: relative;
        display: flex;
        text-decoration: none;
        width: 100%;
    }
    .DXModelCard-details-left,
    .DXModelCard-details-right {
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .DXModelCard-bottom {
        position: relative;
    }
    .DXModelCard-bottom-details {
        position: absolute;
        box-sizing: border-box;
        z-index: 3;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        padding-bottom: 20px;
        align-items: flex-start;
    }
    .DXModelCard-subheading {
        margin: 5px 0px 0px;
    }
    .DXModelCard-subheading-default {
        font-weight: 700;
    }
    .DXModelCard-price-default {
        font-size: 18px;
        line-height: 29px;
    }
    .DXModelCard-details-right {
        flex: 1 0 auto;
        align-items: flex-end;
        margin-left: 8px;
    }
    .DXModelCard-price-wrap {
        position: relative;
        display: flex;
        align-items: center;
        gap: 3px;
    }
    .DXTooltip-trigger svg {
        margin-top: 3px;
        pointer-events: none;
    }
    .DXModelCard-info-list-default .DXModelCard-info-item {
        display: block;
        position: relative;
        &:not(:last-child) {
            &:after {
                content: '';
                position: absolute;
                right: -8px;
                top: 0;
                bottom: 0;
                margin: auto;
                height: 3px;
                width: 3px;
                border: 0px solid transparent;
                border-radius: 50%;
                background-color: #cacccf;
            }
        }
    }
    .DXModelCard-sticker-list {
        margin-right: 12px;
    }
    .DXTooltip-content {
        color: white;
        font-size: 14px;
        line-height: 22px;
        font-family: 'source-sans-pro', sans-serif;
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
